module.exports = __webpack_public_path__ + "img/291-0cad0a.png";